module.exports = __webpack_public_path__ + "img/gb1023.prt.7d578e3d.jpg";